// Styles
import './Energetics.scss';

// Libs
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import Button from '@/common/components/atoms/Button/Button';
// Contexts
import { useModalContext } from '@/common/contexts/ModalContext';
// Assets
import { ReactComponent as EnergeticsIcon } from '@/ebat/assets/images/energetics.svg';
// Blocks
import EnergeticsDetail from '@/ebat/components/blocks/Modal/Product/EnergeticsDetail/EnergeticsDetail';
import EnergyClass from '@/ebat/components/blocks/Product/EnergyClass/EnergyClass';

import {
  EnergeticsDefaultProps,
  EnergeticsPropTypes,
} from './Energetics.proptypes';

const Energetics = ({ className, energetics }) => {
  const { t } = useTranslation();
  const {
    onOpenModal,
    setModalClassName,
    setModalContent,
    setModalSize,
  } = useModalContext();

  const energyClasses = useMemo(
    () =>
      energetics?.energy_classes?.data.filter(
        (energyClass) => energyClass.score,
      ),
    [energetics],
  );

  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    // TODO: Rename
    () => ['product-energetics', className].filter((val) => val).join(' '),
    [className],
  );

  /**
   * Generate energy button classNames
   * @type {string}
   */
  const getButtonClassNames = useMemo(
    () =>
      energyClasses?.length > 1
        ? 'button--energetics-multiple'
        : 'button--energetics-simple',
    [energyClasses],
  );

  const handleOpenModal = useCallback(() => {
    setModalContent(
      <EnergeticsDetail
        energyClasses={energyClasses}
        links={energetics.links}
      />,
    );
    setModalClassName('modal-energetics-detail');
    setModalSize('sm');
    onOpenModal();
  }, [
    energetics,
    energyClasses,
    onOpenModal,
    setModalClassName,
    setModalContent,
    setModalSize,
  ]);

  return (
    <>
      {energyClasses?.length > 0 ? (
        <p className={classNames}>
          <span className="product-energetics__label">
            {t('ebat:entities:product.details.energetics.singular')}
          </span>
          <Button className={getButtonClassNames} onClick={handleOpenModal}>
            {energyClasses?.length === 1 ? (
              <EnergyClass score={energyClasses[0].score} />
            ) : (
              <>
                <EnergeticsIcon className="icon" />
                <span className="label">
                  {t('ebat:entities:product.details.energetics.action')}
                </span>
              </>
            )}
          </Button>
        </p>
      ) : null}
    </>
  );
};

Energetics.defaultProps = {
  ...EnergeticsDefaultProps,
};

Energetics.propTypes = {
  ...EnergeticsPropTypes,
};

export default Energetics;
